var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"circle-icon",style:(`background-color: ${_vm.category.color};`)},[_c('div',{staticClass:"circle-icon-gradient"},[_c('div',{staticClass:"icon icon-shdow",class:'salex sx-'+_vm.category.icon})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }